import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';

import {
  DataConventionSaveDialogComponent,
  DataConventionSaveDialogData,
} from '../data-convention-save-dialog/data-convention-save-dialog.component';
import { OrganizationDataConvention } from 'src/app/models/organizations/organization-data-convention';

@Component({
  selector: 'app-create-data-convention-button',
  templateUrl: './create-data-convention-button.component.html',
  styleUrls: ['./create-data-convention-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class CreateDataConventionButtonComponent {
  private readonly destroyRef = inject(DestroyRef);

  @Input() organizationId: string | null = null;
  @Output() saved = new EventEmitter<OrganizationDataConvention>();

  constructor(private readonly dialog: MatDialog) {}

  openDialog(): void {
    if (this.organizationId === null) return;
    this.dialog
      .open(DataConventionSaveDialogComponent, { data: this.buildDialogData() })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result: OrganizationDataConvention | undefined) => this.onDialogClosed(result));
  }

  private buildDialogData(): DataConventionSaveDialogData {
    return {
      organizationId: this.organizationId as string,
      current: null,
      hasPriorConvention: false,
    };
  }

  private onDialogClosed(result: OrganizationDataConvention | undefined): void {
    if (result) this.saved.emit(result);
  }
}
